import { post } from '../utils/request';

const NoteShare = {};

NoteShare.getArticleDetail = (params) => {
    return post('rike/get_detail_h5', params);
};
NoteShare.checkRegister = (params) => {
    return post('user/check_user_by_wxcode', params);
};

NoteShare.createOrder = (params) => {
    return post('rike/create_order_article_h5', params);
};

NoteShare.getOrderStatus = (params) => {
    return post('rike/get_order_status_h5', params);
};

export default NoteShare;